import { render, staticRenderFns } from "./EditContactBrain.vue?vue&type=template&id=b8c64b7a&scoped=true"
import script from "./EditContactBrain.vue?vue&type=script&lang=js"
export * from "./EditContactBrain.vue?vue&type=script&lang=js"
import style0 from "./EditContactBrain.vue?vue&type=style&index=0&id=b8c64b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c64b7a",
  null
  
)

export default component.exports